import * as React from 'react';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
import { Button, WizzardSteps, WhiteButton } from 'components';
import { PageTitle } from 'components/PortalStructure';

require('./style.css');

interface IProps {
	wizardStep: number;
	title: string;
	pristine: any;
	submitting: any;
	previousPage: () => void;
	cancelClick: () => void;
	t?: (key: string, options?: any) => string;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class OutfitEditorHeader extends React.Component<IProps, any> {
	public render() {
		const { t, wizardStep, title, submitting, pristine } = this.props;

		let saveButton = (
			<Button type="submit" disabled={pristine || submitting}>
				{t('BSPortal_Common_Next')}
			</Button>
		);
		if (wizardStep === 2) {
			saveButton = <Button type="submit">{t('BSPortal_Common_Save')}</Button>;
		}

		return (
			<div className="outfitEditorHeader">
				<div className="container-fluid outfitEditorHeaderContainer">
					<div className="row">
						<div className="col-sm-2 backBtn">
							<WhiteButton onClick={this.props.previousPage}>{t('BSPortal_Common_Back')}</WhiteButton>
						</div>
						<div className="col-sm-2">
							<WizzardSteps currentStep={wizardStep} numberOfSteps={2} />
						</div>
						<div className="col-sm-5">
							<div className="titleModal">
								<PageTitle title={title} />
							</div>
						</div>
						<div className="col-sm-3">
							<div className="wrapperRightSideButtons">
								<WhiteButton onClick={this.props.cancelClick}>{t('BSPortal_Common_Cancel')}</WhiteButton>
								{saveButton}
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export { OutfitEditorHeader };
